import React from 'react';

const Button = React.forwardRef(({ className = '', variant = 'primary', size = 'default', children, ...props }, ref) => {
  
  const baseStyles = "inline-flex items-center justify-center font-semibold transition-colors focus:outline-none disabled:opacity-50 disabled:pointer-events-none";
  
  const variants = {
    primary: "bg-tenant-dark text-white hover:bg-tenant-hover shadow-sm", // Exact green from the design
    secondary: "bg-white text-gray-700 border border-gray-200 hover:bg-gray-50",
    ghost: "bg-transparent text-gray-600 hover:bg-gray-100",
    danger: "bg-red-50 text-red-600 hover:bg-red-100",
  };

  const sizes = {
    default: "h-10 px-4 py-2 text-[13px] rounded-lg",
    sm: "h-8 px-3 text-[12px] rounded-md",
    icon: "h-8 w-8 rounded-md p-1",
  };

  return (
    <button
      ref={ref}
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
});

Button.displayName = 'Button';

export default Button;
